import { useEffect, useRef, useState } from "react";

export const DebouncedInput = ({ value: initialValue, onChange, debounce = 100, ...props }) => {
  const [value, setValue] = useState(initialValue);
  const isFirstRender = useRef(true);

  //   useEffect(() => {
  //     setValue(initialValue);
  //   }, [initialValue]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timeout = setTimeout(() => {
      if (onChange) {
        onChange(value);
      }
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return <input  style={{
          border: "1px solid #abababff",
          borderRadius: "8px",
          padding: "5px",
          fontSize: "16px",
          backgroundColor: "white",
          color: "#333",
          outline: "none",
        }} {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
};
